exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/core-js/modules/_wks-ext.js
 ** module id = 26
 ** module chunks = 12
 **/